exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gJg7bwqKTvKs7HoEfy1G2{padding:1.42857rem 0}._3GPdPFtuVHrXveDetzobJb{padding:0 2.14286rem}._1SSODDxBkJXyjuS3Ho1Oh{margin-bottom:.71429rem}._3xBiM1rmI0A9eQXkDiZ6xq{list-style:none;padding-left:0}._2m4rX5d5I7wR_vZoylKH9k{font-weight:700}._2oS8Xm7oRKOLOA_Ggaobnv{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;list-style:none;padding:.71429rem 2.14286rem}._2oS8Xm7oRKOLOA_Ggaobnv li{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}._2oS8Xm7oRKOLOA_Ggaobnv li:first-child{font-weight:700}._2oS8Xm7oRKOLOA_Ggaobnv li:first-child,._2oS8Xm7oRKOLOA_Ggaobnv li:last-child{-webkit-flex-basis:30%;-ms-flex-preferred-size:30%;flex-basis:30%}.ZnX35NDfFxlhHqqgWl57b{width:50%}._2BtZGtVpMrr16gCt7-8sBg{width:65%}.-Yx06fh-Q8Zdwf6fC8YbJ{min-height:2.5rem}._2u7T263FBplqZaGTLUVBzs{padding:0 2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudyPlan": "gJg7bwqKTvKs7HoEfy1G2",
	"StudyPlan_radio": "_3GPdPFtuVHrXveDetzobJb",
	"StudyPlan_radio_item": "_1SSODDxBkJXyjuS3Ho1Oh",
	"StudyPlan_table": "_3xBiM1rmI0A9eQXkDiZ6xq",
	"StudyPlan_table_header": "_2m4rX5d5I7wR_vZoylKH9k",
	"StudyPlan_table_row": "_2oS8Xm7oRKOLOA_Ggaobnv",
	"StudyPlan_table_row_select": "ZnX35NDfFxlhHqqgWl57b",
	"StudyPlan_table_row_input": "_2BtZGtVpMrr16gCt7-8sBg",
	"StudyPlan_select_option": "-Yx06fh-Q8Zdwf6fC8YbJ",
	"StudyPlan_buttons": "_2u7T263FBplqZaGTLUVBzs"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/StudyPlan/style.postcss
// module id = 1996
// module chunks = 0